import React, { Component, Fragment } from "react"
import PropTypes from "prop-types"
import styled from "styled-components"
import { translate } from "react-i18next"
import { connect } from "react-redux"
import { compose } from "redux"
import { Button, Modal, ModalHeader, ModalBody, ModalFooter } from "reactstrap"
import  ExportMenu from "../../themed-html-components/ExportMenu"
import * as ninebgActions from "../../../state/actions/nineBoxGridDrilldownActions"
import Box from "../nine-box-grid/Box"
import BoxDetail from "../nine-box-grid/BoxDetail"
import PerformanceBanner from "../nine-box-grid/PerformanceBanner"
import PotentialBanner from "../nine-box-grid/PotentialBanner"
import NineBoxGridSummaryShape from "../../../state/shapes/NineBoxGridSummaryShape"
import NineBoxGridDrillDownBoxShape from "../../../state/shapes/NineBoxGridDrilldownBoxShape"
import {
  convertFilterStateToUrlParams,
  convertFilterStateToPostLocations
} from "../../../utils/filter-utils"
import { CHARTS, SORTCOLUMNS } from "../../../constants"

import { media } from "../../../utils/style-utils"

const BoxGrid = styled.div`
  display: inline-block;
  ${media.tablet`display: padding-left: 0 !important`};
`

const OverviewGrid = styled.div`
  padding-left: 100px !important;
  ${media.tablet`padding-left: 0 !important`};
`

const pageSize = 5
const defaultPage = 1
const defaultColumn = SORTCOLUMNS.EmployeeAsc

class Grid extends Component {
  state = {
    activeBoxIndex: -1,
    activeBoxTitle: "",
    activeBoxDrilldown: {},
    boxEmployeeCount: 0,
    includeComparison: this.props.summary != null && this.props.summary.length > 1,
    width: 0,
    showPeopleModal: false,
    exportDisplay: "none"
  }
  componentDidMount() {
    this.updateWindowDimensions()
    window.addEventListener("resize", this.updateWindowDimensions)
  }
  componentWillUnmount() {
    window.removeEventListener("resize", this.updateWindowDimensions)
  }
  getBoxColour = boxIndex => {
    if (boxIndex === 0 || boxIndex === 1 || boxIndex === 3) {
      // Return red
      return CHARTS.trafficLightColours.red
    } else if (boxIndex === 2 || boxIndex === 4 || boxIndex === 6) {
      // Return yellow
      return CHARTS.trafficLightColours.amber
    }
    // Return green
    return CHARTS.trafficLightColours.green
  }
  updateWindowDimensions = () => {
    this.setState({ width: window.innerWidth })
  }
  resetGrid = () => {
    this.setState({
      activeBoxIndex: -1,
      activeBoxTitle: "",
      activeBoxDrilldown: {},
      showPeopleModal: false
    })
  }
  changeActiveBoxIndex = (boxIndex, boxTitle, count) => {
    const displayPeopleModal = this.props.isSmall9BG && boxIndex >= 0

    // With the boxIndex we can now retrieve the drilldown for the box.
    this.setState({
      activeBoxIndex: boxIndex,
      activeBoxTitle: boxTitle,
      showPeopleModal: displayPeopleModal,
      boxEmployeeCount: count
    })

    this.props.loadDrillDownData(
      boxIndex,
      defaultPage,
      pageSize,
      true,
      convertFilterStateToUrlParams(this.props.filters),
      convertFilterStateToPostLocations(this.props.filters),
      this.props.dashboard,
      defaultColumn
    )
  }

  changeActiveBoxPage = (pageNumber, pageSize, orderByColumn) => {
    // With the boxIndex we can now retrieve the drilldown for the box.
    this.props.loadDrillDownData(
      this.state.activeBoxIndex,
      pageNumber,
      pageSize,
      false,
      convertFilterStateToUrlParams(this.props.filters),
      convertFilterStateToPostLocations(this.props.filters),
      this.props.dashboard,
      orderByColumn
    )
  }

  sortBoxes = (boxes, sequence) => {
    const sortedBoxes = []
    // Loop though the sequence and find the matching boxIndex
    for (let s = 0; s < sequence.length; s += 1) {
      for (let b = 0; b < boxes.length; b += 1) {
        // If a match is found then push to the sortedArray for returning
        if (sequence[s] === boxes[b].boxIndex) {
          sortedBoxes.push(boxes[b])
        }
      }
    }
    return sortedBoxes
  }
  toggleExportOn = () => {
    this.setState({ exportDisplay: "initial" })
  }
  toggleExportOff = () => {
    this.setState({ exportDisplay: "none" })
  }
  render() {
    const { drilldown, isSmall9BG, summary, t } = this.props
    const smallScreenWidth = 768

    let boxSequence = [6, 7, 8, 3, 4, 5, 0, 1, 2]

    // For smalle screen / mobile we want to show the boxes in a different sequence
    if (this.state.width < smallScreenWidth) {
      boxSequence = [8, 7, 5, 2, 4, 6, 3, 1, 0]
    }

    let primaryReview = { ...summary[0] }
    let comparisonReview = null

    if (summary.length > 1) {
      comparisonReview = { ...summary[0] }
      primaryReview = { ...summary[1] }
    }

    // Sort the primary review boxes into the default 9BG sequence
    const sortedPrimaryBoxes = this.sortBoxes(primaryReview.boxes, boxSequence)

    primaryReview.boxes = sortedPrimaryBoxes

    // Build up the boxes for display
    const boxes = primaryReview.boxes.map((box, index) => {
      let comparisonBox = null
      // If there is a comparison review then we need to look for the box values
      // for the comparison
      if (comparisonReview != null) {
        for (let i = 0; i < comparisonReview.boxes.length; i += 1) {
          // When a match is found set the comparisonBox
          if (box.boxIndex === comparisonReview.boxes[i].boxIndex) {
            comparisonBox = comparisonReview.boxes[i]
          }
        }
      }

      return (
        <Box
          key={box.boxIndex}
          isSmall9BG={isSmall9BG}
          boxIndex={box.boxIndex}
          title={box.boxTitle}
          count={box.employeeCount}
          percentage={box.percentOfTotal}
          colour={this.getBoxColour(box.boxIndex)}
          includeComparison={!isSmall9BG && this.state.includeComparison}
          comparisonPercentage={comparisonBox == null ? null : comparisonBox.percentOfTotal}
          onClickEvent={this.changeActiveBoxIndex}
        />
      )
    })

    const boxDetail = (
      <BoxDetail
        title={this.state.activeBoxTitle}
        details={drilldown}
        onClickEvent={this.resetGrid}
        totalItemsCount={this.state.boxEmployeeCount}
        onChangePage={this.changeActiveBoxPage}
        showPeopleModal={this.state.showPeopleModal}
      />
    )

    return (
      <div
        id={`nine-box-grid-${isSmall9BG ? "small" : "large"}`}
        className="row"
        style={{ paddingRight: this.state.width > smallScreenWidth ? "50px" : "", flex: 1 }}
        onMouseEnter={this.toggleExportOn} 
        onMouseLeave={this.toggleExportOff}
      >
        <ExportMenu titleKey={this.props.titleKey}
                    display={this.state.exportDisplay} 
                    left={isSmall9BG ? "580px" : "900px"} 
                    top={isSmall9BG ? "80px" : "90px"}
                    widgetIdentifier={this.props.widgetIdentifier}
                    resetDisplayProp={this.toggleExportOff}/>
        <BoxGrid className="col-lg-12 col-md-12">
          {this.state.showPeopleModal ||
          drilldown === null ||
          (drilldown !== null && this.state.activeBoxIndex === -1) ? (
            <Fragment>
              <OverviewGrid>
                {boxes}
                <PotentialBanner
                  isSmall9BG={isSmall9BG}
                  boxesHaveComparison={!isSmall9BG && this.state.includeComparison}
                />
                <PerformanceBanner />
              </OverviewGrid>
              {isSmall9BG &&
                this.state.showPeopleModal && (
                  <Modal
                    isOpen={this.state.showPeopleModal}
                    toggle={this.resetGrid}
                    className="xl-modal"
                  >
                    <ModalHeader toggle={this.resetGrid}>
                      {t(this.state.activeBoxTitle)}
                    </ModalHeader>
                    <ModalBody>{drilldown !== null && boxDetail}</ModalBody>
                    <ModalFooter>
                      <Button color="secondary" onClick={this.resetGrid}>
                        {t("Common.Close")}
                      </Button>
                    </ModalFooter>
                  </Modal>
                )}
            </Fragment>
          ) : (
            <Fragment>{boxDetail}</Fragment>
          )}
        </BoxGrid>
      </div>
    )
  }
}

Grid.propTypes = {
  isSmall9BG: PropTypes.bool,
  summary: PropTypes.arrayOf(PropTypes.shape(NineBoxGridSummaryShape)).isRequired,
  drilldown: PropTypes.shape(NineBoxGridDrillDownBoxShape),
  loadDrillDownData: PropTypes.func.isRequired,
  dashboard: PropTypes.string.isRequired,
  widgetIdentifier: PropTypes.string.isRequired,
  titleKey: PropTypes.string
}

Grid.defaultProps = {
  isSmall9BG: false,
  drilldown: null
}

function mapStateToProps(state) {
  return {
    filters: state.filters
  }
}

function mapDispatchToProps(dispatch) {
  return {
    loadDrillDownData: (
      boxIndex,
      pageNumber,
      pageSize,
      reloadPage,
      filtersAsParams,
      filterLocations,
      dashboard,
      orderByColumn
    ) =>
      dispatch(
        ninebgActions.load9BGDetail(
          boxIndex,
          pageNumber,
          pageSize,
          reloadPage,
          filtersAsParams,
          filterLocations,
          dashboard,
          orderByColumn
        )
      )
  }
}

export default compose(translate(), connect(mapStateToProps, mapDispatchToProps))(Grid)



// WEBPACK FOOTER //
// ./src/components/charts/nine-box-grid/Grid.jsx